import * as React from "react";
import { Box, Button, Stack, Typography, Grid } from "@mui/material";
import MenuAppBar from "./dashboardNavBar";
import addLogo from "../../assets/svg/plus.svg";
import truckLogo from "../../assets/svg/truck.svg";
import uploadLogo from "../../assets/svg/upload.svg";
import { useNavigate, useLocation } from "react-router-dom";
import { useResponsive } from "../../hooks/useResponsive";
import MenuBar from "../menuBar";
import { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  doOpenGate,
  getLocationGatesList,
  getLocationSolrListApi,
  getReserverationList,
  reservationsDetailsRequest,
  saveReservationStateData,
  setSelectedReservationItem,
  setSelectedGates,
} from "../../redux/reservations/action";

import CustomLoader from "../../components/CustomLoader";
import BookReservationCard from "../../components/reservation/BookReservationCard";
import CarouselWithIndicator from "../../components/CarouselWithIndicator";
import CustomSerachBar from "../../components/CustomSerachBar";
import storePersist, { localConstant } from "../../services/localStorage";
import BottomNav from "../../components/BottomNav/BottomNav";
import CustomDialog from "../../components/CustomDialog";
import InviteDrivers from "../drivers/inviteDrivers";
import AddVehicles from "../vehicles/addVehicles";
import UploadDocuments from "../uploadDocuments";
import InfiniteScroll from "react-infinite-scroller";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./styles.css";
import {
  getDeviceName,
  isAppInLatestVersion,
  isMobileDeviceCheck,
  sendMessageToReactNative,
} from "../../utils";
import { updateReservationCheckout } from "../../redux/reservations/constants";
import { getAdobeDocument } from "../../redux/storageDocument/action";
import Alert from "../../components/Alert";
import EsignAgreementAlert from "../../components/EsignAgreementAlert";
import { useState } from "react";
import FullPageModal from "../../components/FullPageLoader";
import {
  ENV,
  MOBILE_LATEST_VERSION,
} from "../../services/apiManager/apiConfig";
import CustomModal from "../../components/CustomModal";
import { NewVersionModal } from "../../components/NewVersionModal";
import { enqueueSnackbar } from "notistack";
import SnackbarConfig from "../../utils/snackbarConfig";
import GatePin from "./gatePins";
import { HereAboutUsModal } from "./hereAboutUs";
import {
  setStatusHereAboutUs,
  UpdateModalState,
} from "../../redux/login/action";
import { fetchCustomerEsignStatus } from "../../services/apiManager/apiRequests";
import { getVehicles } from "../../redux/vehicle/action";

const OwnerDashboard = (props) => {
  const dispatch = useDispatch();

  const [ownerVehicles, setOwnerVehicles] = useState([]);
  const [ownerVehiclesLoading, setOwnerVehiclesLoading] = useState(true);
  useEffect(() => {
    const entity_customer_id = storePersist.get(
      localConstant.ENTITY_CUSTOMER_ID,
    );
    dispatch(
      getVehicles({ cust_id: entity_customer_id }, (data) => {
        setOwnerVehicles(data);
        setOwnerVehiclesLoading(false);
      }),
    );
  }, []);
  const {
    isLoading,
    locationData,
    reservationList,
    selectedReservation,
    gateList,
  } = useSelector((state) => state.reservationReducer);

  const { current } = useSelector((state) => state.loginReducer);
  const appVersion = storePersist.get(localConstant.APP_VERSION);
  const { isForceUpdate } = useSelector((state) => state.loginReducer);

  const [appCurrentVersion, setCurrentAppVersion] = useState(appVersion);
  useEffect(() => {
    setCurrentAppVersion(appVersion);
  }, [appVersion]);
  useEffect(() => {
    window.clarity(
      "set",
      "customer_id",
      storePersist.get(localConstant.ENTITY_CUSTOMER_ID),
    );
    window.clarity("set", "user_id", storePersist.get(localConstant.USER_ID));
  }, []);
  const onCancelUpdateModal = () => {
    dispatch(UpdateModalState(false));
  };

  const navigate = useNavigate();
  const location = useLocation();
  const lgUp = useResponsive("up", "lg");
  React.useEffect(() => {
    if (location.state?.openAddVehicleDialog) {
      setDialogProps((prev) => ({
        ...prev,
        isOpen: true,
        title: "Add Vehicle",
        Content: AddVehicles,
      }));
    }
  }, [location]);

  const smDown = useResponsive("down", "sm");
  const [gateOpenLoading, setGateOpenLoading] = useState(false);
  const hereAboutUsLabelState =
    current?.userReferralDetails === "" ||
    current?.userReferralDetails === null;

  const [hereAboutUsModalState, setHereAbotUsModalState] = useState(false);
  const myRef = useRef({});

  const [gateCordinatedResponseTime, setGateCordinatedResponseTime] = useState(
    new Date(null),
  );

  const [dialogProps, setDialogProps] = React.useState({
    isOpen: false,
    Content: null,
    reset: () =>
      setDialogProps((prev) => ({ ...prev, isOpen: false, Content: null })),
  });

  const [popupDialogProps, setPopupDialogProps] = useState({
    isOpen: false,
    content: "",
    reset: () =>
      setPopupDialogProps((prev) => ({
        ...prev,
        isOpen: false,
        content: "",
      })),
  });

  const [esignPopupDialogProps, setEsignPopupDialogProps] = useState({
    isOpen: false,
    item: {},
    gate: {},
    reset: () =>
      setEsignPopupDialogProps((prev) => ({
        ...prev,
        isOpen: false,
        item: {},
        gate: {},
      })),
  });

  const openGateForCustomer = (item, gate) => {
    setGateCordinatedResponseTime(new Date());
    setGateOpenLoading(true);
    let { equipment_id } = gate || {};
    dispatch(setSelectedReservationItem({ ...item, equipment_id }));
    sendMessageToReactNative("GET_DEVICE_LOCATION");
  };

  const { t } = useTranslation();

  const checkForEsign = () => {
    if (
      storePersist.get(localConstant.AGREEMENT_STATUS) !== "COMPLTD" &&
      storePersist.get(localConstant.AGREEMENT_STATUS) !== "COMPLETED" &&
      storePersist.get(localConstant.AGREEMENT_ID)
    ) {
      const currentTime = new Date().getTime();
      let timestampForEsign = storePersist.get(
        localConstant.TIMESTAMP_FOR_ESIGN,
      );
      if (!timestampForEsign)
        timestampForEsign = storePersist.get(localConstant.LOGIN_TIMESTAMP);
      const timeDifference = currentTime - timestampForEsign;
      dispatch(
        getAdobeDocument(
          storePersist.get(localConstant.AGREEMENT_ID),
          (response) => {
            if (
              response?.response?.agreementStatus === "COMPLETED" ||
              response?.response?.participant?.[0]?.signStatus === "SIGNED"
            ) {
              storePersist.set(localConstant.AGREEMENT_STATUS, "COMPLTD");
            } else if (
              response?.response?.agreementStatus === "IN_PROGESS" ||
              response?.response?.participant?.[0]?.signStatus === "IN_PROGESS"
            ) {
              if (timeDifference > 120000) {
                storePersist.set(
                  localConstant.AGREEMENT_STATUS,
                  "OUT_FOR_SIGNATURE",
                );
                return navigate("/ownerDashboard");
              }
            }
          },
        ),
      );
    }
  };

  React.useEffect(() => {
    const paramsNoSearch = {
      "q.op": "OR",
      start: "0",
      rows: "10000",
      wt: "json",
      cl: "OPS",
      sort: "location_city asc",
    };

    dispatch(getLocationSolrListApi(paramsNoSearch, (response) => {}));
  }, []);

  React.useEffect(() => {
    const custId = storePersist.get(localConstant.ENTITY_CUSTOMER_ID);
    const params = {
      "q.op": "OR",
      start: "0",
      rows: "10000",
      wt: "json",
      cl: "OPS",
      fq: `reservation_status: (PNDG_COUT CONFIRMED PNDG_CONF PNDG_EXT)`,
    };
    dispatch(getReserverationList(params, (response) => {}));
  }, []);

  React.useEffect(() => {
    const getEsignInformation = async () => {
      const esignStatus = await fetchCustomerEsignStatus();
      if (esignStatus?.agrmntStatusCd && esignStatus?.agrmntId) {
        storePersist.set(
          localConstant.AGREEMENT_STATUS,
          esignStatus?.agrmntStatusCd,
        );
        storePersist.set(localConstant.AGREEMENT_ID, esignStatus?.agrmntId);
        checkForEsign();
      }
    };

    getEsignInformation();
  }, []);

  const [tempData, setTempData] = React.useState([]);
  const [pointer, setPointer] = React.useState(1);

  useEffect(() => {
    setTempData([]);
  }, [locationData]);

  const fetchData = () => {
    if (locationData?.length > tempData?.length) {
      setTempData([...locationData.slice(0, 2 * pointer)]);
      setPointer(pointer + 1);
    }
  };
  React.useEffect(() => {
    if (reservationList?.length > 0) {
      const uniq = {};
      for (let index = 0; index < reservationList?.length; index++) {
        const element = reservationList[index];
        if (
          element.location_id &&
          (element.reservation_status === "CONFIRMED" ||
            element.reservation_status === "PNDG_EXT")
        ) {
          const locationId = element.location_id;
          if (!Object.keys(uniq).includes(locationId)) {
            uniq[locationId] = locationId;
          }
        }
      }
      const locations = Object.keys(uniq).toString().replace(/,/g, " ");
      if (Object.keys(uniq)?.length > 0) {
        const params = {
          fq: `location_id: (${locations})&fq=equipment_type_code:GATE&fq=equipment_status_code:ACTIVE&start=0&rows=10000`,
        };
        dispatch(getLocationGatesList(params, (response) => {}));
      }
    }
  }, [reservationList, dispatch]);

  const setGateLoadingState = (state) => {
    setGateOpenLoading(state);
  };

  // removing for current release IOS  1.2 ...

  // useEffect(() => {
  //   if (isMobileDeviceCheck() && isAppInLatestVersion(appVersion)) {
  //     sendMessageToReactNative(
  //       `CHECK_USER_APP_VERSION:${JSON.stringify(MOBILE_LATEST_VERSION)}`
  //     );
  //   }
  // }, []);

  const API_ACCESS = storePersist.get(localConstant.API_ACCESS_TOKEN);
  const USER_PROFILE = storePersist.get(localConstant.USER_PROFILE);

  const onMessageFromRN = (message) => {
    try {
      const { action, payload } = JSON.parse(message);
      if (action === "User_Location") {
        // time difference between gate button clicked and  getting cordinated response...
        const currentTime = new Date();
        const timeDifference = Math.floor(
          currentTime - gateCordinatedResponseTime,
        );
        if (
          payload === null ||
          payload === undefined ||
          payload?.coords?.latitude === undefined ||
          payload?.coords?.longitude === undefined ||
          payload?.coords?.latitude === null ||
          payload?.coords?.longitude === null
        ) {
          enqueueSnackbar("Failed to fetch gate access details.", {
            variant: "error",
            autoHideDuration: 3000,
            action: SnackbarConfig,
          });
          setGateOpenLoading(false);
        } else {
          setGateOpenLoading(true);
          dispatch(
            doOpenGate(
              {
                lat: payload?.coords?.latitude,
                lng: payload?.coords?.longitude,
                gateId: selectedReservation?.equipment_id || "",
                reservationId: selectedReservation?.reservation_id,
                fetchLatLongTimeInMillis: timeDifference,
              },
              (response) => {
                console.log("doOpenGate Response:", response);
              },
              setGateLoadingState,
            ),
          );
        }
      }
    } catch (error) {
      console.error("Error parsing message:", error);
    }
  };

  // Attach the handler to `window` so we can access it from
  // scripts injected by React Native WebView.
  window.onMessageFromRN = onMessageFromRN;

  const setHereAbotUsModalFunc = (value) => {
    setHereAbotUsModalState(value);
  };

  const getDataFromHereAboutUS = (data) => {
    setGateOpenLoading(true);
    dispatch(
      setStatusHereAboutUs(data, () => {
        setGateOpenLoading(false);
        enqueueSnackbar("Referral details added successfully", {
          variant: "success",
          autoHideDuration: 3000,
          action: SnackbarConfig,
        });
      }),
    );
    setHereAbotUsModalState(false);
  };

  const customerEsignStatus = async () => {
    if (
      storePersist.get(localConstant.AGREEMENT_STATUS) === "COMPLTD" ||
      storePersist.get(localConstant.AGREEMENT_STATUS) === "COMPLETED"
    ) {
      return true;
    } else {
      const esignStatus = await fetchCustomerEsignStatus();
      if (
        esignStatus?.agrmntStatusCd === "COMPLETED" ||
        esignStatus?.agrmntStatusCd === "COMPLTD"
      ) {
        storePersist.set(
          localConstant.AGREEMENT_STATUS,
          esignStatus?.agrmntStatusCd,
        );
        storePersist.set(localConstant.AGREEMENT_ID, esignStatus?.agrmntId);
        return true;
      }
      storePersist.set(localConstant.AGREEMENT_ID, esignStatus?.agrmntId);
      return false;
    }
  };

  const displayEsginRequestMessage = (item, gate) => {
    setEsignPopupDialogProps((prev) => ({
      ...prev,
      isOpen: true,
      item,
      gate,
    }));
  };

  return (
    <div
      style={{
        width: lgUp ? `calc(100% - ${240}px)` : "100%",
        marginLeft: lgUp ? "240px" : 0,
      }}
    >
      <MenuAppBar myRef={myRef} title={t("pages.ownerDashboard.pageHeading")} />
      <MenuBar myRef={myRef} activeTab={0} />
      <Box
        sx={{
          m: lgUp && 3.5,
          mb: 8,
          display: "flex",
          flexDirection: "column",
          minHeight: 700,
          overflow: "hidden",
          overflowY: "scroll",
          p: 1,
        }}
      >
        {storePersist.get(localConstant.USER_PROFILE) === "OWNER" &&
          storePersist.get(localConstant.AGREEMENT_STATUS) !== "COMPLTD" &&
          storePersist.get(localConstant.AGREEMENT_STATUS) !== "COMPLETED" &&
          storePersist.get(localConstant.AGREEMENT_STATUS) !== "IN_PRGRS" &&
          storePersist.get(localConstant.AGREEMENT_STATUS) !== "IN_PROGESS" && (
            <>
              <Typography
                style={{
                  fontFamily: "Segoe UI",
                  fontSize: 16,
                  fontWeight: 700,
                  letterSpacing: 0,
                  textAlign: "left",
                  color: "#1D5AB9",
                  margin: 10,
                }}
              >
                {t("pages.ownerDashboard.title04")}
              </Typography>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  justifyContent: "space-between",
                  borderRadius: "8px",
                  padding: "2%",
                  background: "linear-gradient(to right, #306FD1, #182E66)",
                  position: "relative",
                  margin: "0 2%",
                }}
              >
                <div class="circles">
                  <div class="inner-circle"></div>
                  <div class="outer-circle"></div>
                </div>
                <span
                  style={{
                    color: "white",
                    fontSize: "90%",
                    marginLeft: isMobileDeviceCheck() ? "15px" : "2px",
                  }}
                >
                  {t("pages.ownerDashboard.text01")}
                </span>
                <Button
                  onClick={() => {
                    if (
                      storePersist.get(localConstant.AGREEMENT_STATUS) ===
                      "DECLINED"
                    ) {
                      setPopupDialogProps((prev) => ({
                        ...prev,
                        isOpen: true,
                        content:
                          "Esign Agreement was declined. Please try again after some time while a new agreement is being created !",
                      }));
                    } else navigate("/adobeDocument");
                  }}
                  maxWidth={200}
                  size="small"
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={
                    storePersist.get(localConstant.AGREEMENT_STATUS) ===
                      "IN_PRGRS" ||
                    storePersist.get(localConstant.AGREEMENT_STATUS) ===
                      "IN_PROGESS"
                  }
                  style={{
                    width: "115px",
                    height: "40px",
                    backgroundColor: "#fff",
                    borderColor: "#8A8886",
                    color: "#605E5C",
                    borderRadius: "8px",
                  }}
                >
                  {storePersist.get(localConstant.AGREEMENT_STATUS) ===
                    "IN_PRGRS" ||
                  storePersist.get(localConstant.AGREEMENT_STATUS) ===
                    "IN_PROGESS"
                    ? t("pages.ownerDashboard.text03")
                    : t("pages.ownerDashboard.text02")}
                </Button>
              </div>
            </>
          )}
        {hereAboutUsLabelState && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              justifyContent: "space-between",
              borderRadius: "8px",
              padding: "2%",
              background: "linear-gradient(to right, #306FD1, #182E66)",
              position: "relative",
              margin: "0 2%",
              marginTop: "20px",
            }}
          >
            <div class="circles">
              <div class="inner-circle"></div>
              <div class="outer-circle"></div>
            </div>
            <span
              style={{
                color: "white",
                fontSize: "90%",
                marginLeft: isMobileDeviceCheck() ? "15px" : "2px",
              }}
            >
              How Did You Hear About Us ?
            </span>
            <Button
              onClick={() => {
                setHereAbotUsModalFunc(true);
              }}
              maxWidth={200}
              size="small"
              type="submit"
              variant="contained"
              color="primary"
              style={{
                width: "115px",
                height: "40px",
                backgroundColor: "#fff",
                borderColor: "#8A8886",
                color: "#605E5C",
                borderRadius: "8px",
              }}
            >
              Tell Us
            </Button>
          </div>
        )}
        {!ownerVehiclesLoading && ownerVehicles.length === 0 && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              justifyContent: "space-between",
              borderRadius: "8px",
              padding: "2%",
              background: "linear-gradient(to right, #306FD1, #182E66)",
              position: "relative",
              margin: "0 2%",
              marginTop: "20px",
            }}
          >
            <div className="circles">
              <div className="inner-circle"></div>
              <div className="outer-circle"></div>
            </div>
            <span
              style={{
                color: "white",
                fontSize: "90%",
                marginLeft: isMobileDeviceCheck() ? "15px" : "2px",
              }}
            >
              {t("customerAlertMessages.vehicleDetailsAdd")}
            </span>
            <Button
              onClick={() => {
                if (smDown) {
                  navigate("/addVehicles");
                } else {
                  setDialogProps((prev) => ({
                    ...prev,
                    isOpen: true,
                    title: "Add Vehicle",
                    Content: AddVehicles,
                  }));
                }
              }}
              maxWidth={200}
              size="small"
              type="submit"
              variant="contained"
              color="primary"
              style={{
                width: "115px",
                height: "40px",
                backgroundColor: "#fff",
                borderColor: "lightgray",
                color: "#605E5C",
                borderRadius: "8px",
              }}
            >
              Add Vehicles
            </Button>
          </div>
        )}
        <div
          style={{
            flexDirection: "row",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            margin: 10,
          }}
        >
          <Typography
            style={{
              fontFamily: "Segoe UI",
              fontSize: 16,
              fontWeight: 700,
              letterSpacing: 0,
              textAlign: "left",
              color: "#1D5AB9",
            }}
          >
            {`${t("pages.ownerDashboard.title01")} (${
              reservationList?.length ? reservationList?.length : "0"
            })`}
          </Typography>
        </div>
        {reservationList?.length > 0 && (
          <CarouselWithIndicator
            data={reservationList}
            gateList={gateList}
            onClickGate={async (item, gate) => {
              const isEsignComplete = await customerEsignStatus();
              if (!isEsignComplete) {
                displayEsginRequestMessage(item, gate);
              } else {
                openGateForCustomer(item, gate);
              }
            }}
            onPressPayNow={(item, gates) => {
              dispatch(setSelectedGates(gates));
              dispatch(setSelectedReservationItem(item));
              dispatch(
                reservationsDetailsRequest(item?.reservation_id, (response) => {
                  navigate("/makePayment", {
                    state: {
                      ...response,
                      hideCancel: true,
                      billing: {
                        charges: [
                          {
                            totalAmount: response?.billing?.[0]?.dueAmount,
                            billNums: response?.billing?.[0]?.dueBillNums,
                          },
                        ],
                      },
                      reservationId: response?.reservationId,
                    },
                  });
                }),
              );
            }}
            onPress={(item, gates) => {
              dispatch(setSelectedGates(gates));
              dispatch(setSelectedReservationItem(item));
              dispatch(
                reservationsDetailsRequest(item?.reservation_id, (response) => {
                  navigate("/reservation_details", {
                    state: { spotData: response, from: "/ownerDashboard" },
                  });
                }),
              );
            }}
          />
        )}

        {/* removing gate pins for current release.... */}

        {/* <Grid>
          <GatePin />
        </Grid> */}
        <Stack
          style={{
            margin: 10,
            flexDirection: "row",
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            gap: 10,
            marginTop: lgUp ? "2%" : "5%",
          }}
        >
          <Box
            border={4}
            borderLeft={0}
            borderRight={0}
            borderColor="primary.secondary"
            sx={{ boxShadow: 1 }}
            style={{
              width: 104,
              height: 71,
              borderRadius: 8,
              borderColor: "lightgray",
              borderWidth: 1,
              alignContent: "center",
              marginRight: `${lgUp ? "2%" : "0"}`,
            }}
          >
            <div
              onClick={() => {
                if (smDown) {
                  navigate("/inviteDrivers");
                  return;
                }
                setDialogProps((prev) => ({
                  ...prev,
                  isOpen: true,
                  title: "Invite Driver",
                  Content: InviteDrivers,
                }));
              }}
              style={{
                alignItems: "center",
                flexDirection: "column",
                display: "flex",
                alignContent: "center",
                cursor: "pointer",
              }}
            >
              <img
                src={addLogo}
                alt="Your Alt Text"
                style={{
                  width: 32,
                  height: 32,
                  marginTop: 7,
                  marginBottom: 7,
                  backgroundColor: "#1D5AB929",
                  borderRadius: "50%",
                }}
              />
              <Typography
                style={{
                  fontFamily: "Segoe UI",
                  fontSize: 9,
                  fontWeight: 400,
                  letterSpacing: 0,
                  textAlign: "center",
                  color: "#3A4454",
                }}
              >
                {t("pages.ownerDashboard.actionItem02")}
              </Typography>
            </div>
          </Box>
          <Box
            border={4}
            borderLeft={0}
            borderRight={0}
            sx={{ boxShadow: 1 }}
            style={{
              width: 104,
              height: 71,
              borderRadius: 8,
              borderWidth: 1,
              borderColor: "lightgray",
              marginRight: `${lgUp ? "2%" : "0"}`,
            }}
          >
            <div
              onClick={() => {
                if (smDown) {
                  navigate("/addVehicles");
                  return;
                }
                setDialogProps((prev) => ({
                  ...prev,
                  isOpen: true,
                  title: "Add Vehicle",
                  Content: AddVehicles,
                }));
              }}
              style={{
                alignItems: "center",
                flexDirection: "column",
                display: "flex",
                alignContent: "center",
                cursor: "pointer",
              }}
            >
              <img
                src={truckLogo}
                alt="Your Alt Text"
                style={{
                  width: 32,
                  height: 32,
                  marginTop: 7,
                  marginBottom: 7,
                  backgroundColor: "#1D5AB929",
                  borderRadius: "50%",
                }}
              />
              <Typography
                style={{
                  fontFamily: "Segoe UI",
                  fontSize: 9,
                  fontWeight: 400,
                  letterSpacing: 0,
                  textAlign: "center",
                  color: "#3A4454",
                }}
              >
                {t("pages.ownerDashboard.actionItem03")}
              </Typography>
            </div>
          </Box>
          <Box
            border={4}
            borderLeft={0}
            borderRight={0}
            sx={{ boxShadow: 1 }}
            style={{
              width: 104,
              height: 71,
              borderRadius: 8,
              borderWidth: 1,
              borderColor: "lightgray",
              marginRight: `${lgUp ? "2%" : "0"}`,
            }}
          >
            <div
              onClick={() => {
                if (smDown) {
                  navigate("/uploadDocuments");
                  return;
                }
                setDialogProps((prev) => ({
                  ...prev,
                  isOpen: true,
                  title: "Upload Documents",
                  Content: UploadDocuments,
                }));
              }}
              style={{
                alignItems: "center",
                flexDirection: "column",
                display: "flex",
                alignContent: "center",
                cursor: "pointer",
              }}
            >
              <img
                src={uploadLogo}
                alt="Your Alt Text"
                style={{
                  width: 32,
                  height: 32,
                  marginTop: 7,
                  marginBottom: 7,
                  backgroundColor: "#1D5AB929",
                  borderRadius: "50%",
                }}
              />
              <Typography
                style={{
                  fontFamily: "Segoe UI",
                  fontSize: 9,
                  fontWeight: 400,
                  letterSpacing: 0,
                  textAlign: "center",
                  color: "#3A4454",
                }}
              >
                {t("pages.ownerDashboard.actionItem04")}
              </Typography>
            </div>
          </Box>
        </Stack>

        <Stack>
          <Stack>
            <div
              style={{
                flexDirection: "row",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                margin: 10,
              }}
            >
              <Typography
                style={{
                  fontFamily: "Segoe UI",
                  fontSize: 16,
                  fontWeight: 700,
                  letterSpacing: 0,
                  textAlign: "left",
                  color: "#1D5AB9",
                }}
              >
                {t("pages.ownerDashboard.title03")}
              </Typography>
            </div>
            <CustomSerachBar
              tiltle={""}
              onSearchClick={(serachText) => {
                // setSearchText(serachText);
                const paramsSearch = {
                  "q.op": "OR",
                  start: "0",
                  rows: "10000",
                  wt: "json",
                  cl: "OPS",
                  q: serachText,
                };

                const paramsNoSearch = {
                  "q.op": "OR",
                  start: "0",
                  rows: "10000",
                  wt: "json",
                  cl: "OPS",
                };

                const searchParams = serachText ? paramsSearch : paramsNoSearch;

                dispatch(
                  getLocationSolrListApi(searchParams, (response) => {}),
                );
              }}
            />
            <InfiniteScroll
              pageStart={0}
              loadMore={() => fetchData()}
              hasMore={true}
              loader={<div className="loader" key={0}></div>}
            >
              <Grid container rowSpacing={1} columnSpacing={1}>
                {tempData?.length > 0 ? (
                  tempData?.map((item, index) => {
                    return (
                      <Grid item xs={12} sm={6} lg={4}>
                        <BookReservationCard
                          key={index}
                          data={item}
                          onClick={() => {
                            dispatch(updateReservationCheckout({}));
                            dispatch(saveReservationStateData(item));
                            navigate("/makeReservation", { state: item });
                          }}
                        />
                      </Grid>
                    );
                  })
                ) : (
                  <></>
                )}
              </Grid>
            </InfiniteScroll>
          </Stack>
        </Stack>
      </Box>
      <BottomNav activeTab={0} />
      {popupDialogProps.isOpen && <Alert {...popupDialogProps} />}
      {esignPopupDialogProps.isOpen && (
        <EsignAgreementAlert
          {...esignPopupDialogProps}
          handleGateOpen={openGateForCustomer}
        />
      )}
      {isLoading && <CustomLoader />}
      {dialogProps.isOpen && <CustomDialog {...dialogProps} />}
      {gateOpenLoading && <FullPageModal />}
      {isForceUpdate &&
        isMobileDeviceCheck() &&
        !isAppInLatestVersion(appCurrentVersion) && (
          <CustomModal>
            <NewVersionModal
              versionApp
              appCurrentVersion={appCurrentVersion}
              onCancelUpdateModal={onCancelUpdateModal}
            />
          </CustomModal>
        )}
      {/* {dialogProps.isOpen && <Alert {...dialogProps} />} */}
      {hereAboutUsModalState && (
        <CustomModal isOpen={hereAboutUsModalState}>
          <HereAboutUsModal
            setHereAbotUsModalFunc={setHereAbotUsModalFunc}
            getDataFromHereAboutUS={getDataFromHereAboutUS}
          />
        </CustomModal>
      )}
    </div>
  );
};

export default OwnerDashboard;
